<template>
  <div>
    <ImageViewCardList
      v-if="hasTrailMaps"
      :images="allTrailMaps"
      image-type="trail_map"
      :is-favorites="isFavorites"
    />
    <NoFavoritesMessage
      v-else
      class="tw-py-10 lg:tw-py-16"
      :is-favorites="isFavorites"
      view="trail-maps"
      @favorites-added="handleFavoritesAdded"
    />
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { useUserStore } from '@@/stores/User';
import ShowImagesMixin from '@@/components/Location/Mixins/ShowImagesMixin';

export default {
  name: 'TrailMapCardList',

  mixins: [
    ShowImagesMixin,
  ],

  props: {
    isFavorites: {
      type: Boolean,
      default: false,
    },
    trailMaps: {
      type: Array,
      default: null,
    },
    locations: {
      type: Array,
      default: null,
    },
  },

  emits: ['favorites-added'],

  computed: {
    ...mapState(useUserStore, ['isAllAccess']),

    allTrailMaps() {
      if (!this.hasTrailMaps) {
        return [];
      }

      return this.trailMaps.map((trailMap) => {
        const location = this.locations.find((l) => l.id === trailMap.location_id);
        return { image: trailMap, location };
      });
    },

    hasTrailMaps() {
      return this.trailMaps?.length > 0;
    },

    location() {
      return this.isFavorites ? null : this.locations?.[0];
    },
  },

  methods: {
    handleFavoritesAdded(countFavoritesAdded) {
      this.$emit('favorites-added', countFavoritesAdded);
    },
  },
};
</script>
